import consts from "@/consts.js";
import Request from './request';

async function fetch(data) {
    return Request('get', "api/stock-positions", data);
}

async function fetchAll(data) {
    if (!data) data = {};
    data.limit = consts.limitAll; //获取全部
    return Request('get', "api/stock-positions", data);
}

async function fetchAllForSelect(data) {
    if (!data) data = {};
    data.limit = consts.limitAll; //获取全部
    return Request('get', "api/stock-positions/select", data, false, false, true);
}

async function save(id, data) {// 编辑或新建数据（有id为编辑，没有id为新建）
  if(id){
    return Request('post', "api/stock-positions/edit?id=" + id, data);
  } else {
    return Request('post', "api/stock-positions/add" , data);
  }
}

async function del(id) {
  return Request('get' , "api/stock-positions/delete/"+id)
}

async function imports(file) {// 导入
    var data = new FormData();
    data.append("excel", file);
    return Request('post', "api/stock-positions/import", data);
}


export default {
    fetch,
    fetchAll,
    fetchAllForSelect,
    save,
    del,
    imports,
};